import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-3b263308"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "sidebar" }
const _hoisted_2 = { class: "section-header" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "dot" }, "•", -1))

import { ref, onMounted } from 'vue'
import { apiRedis } from '@/api/index'


export default /*#__PURE__*/_defineComponent({
  __name: 'SlideProfile',
  setup(__props) {

const blogsType = ref<any[]>([])

onMounted(async () => {
  await getBlogsType()
})

const buildTree = (data: any[]) => {
  const map: any = {}
  const roots: any[] = []

  data.forEach(item => {
    map[item.id] = { ...item, children: [] }
  })

  data.forEach(item => {
    if (item.parent_id) {
      map[item.parent_id]?.children.push(map[item.id])
    } else {
      roots.push(map[item.id])
    }
  })

  return roots
}

const getBlogsType = async () => {
  const res: any = await apiRedis("profile-blogs-type")
  const data = JSON.parse(res.data.data)

  blogsType.value = buildTree(data)
  console.log('blogsType',blogsType)
}

return (_ctx: any,_cache: any) => {
  const _component_a_menu_item = _resolveComponent("a-menu-item")!
  const _component_a_menu = _resolveComponent("a-menu")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(blogsType.value, (item) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "section",
        key: item.id
      }, [
        _createElementVNode("div", _hoisted_2, _toDisplayString(item.title), 1),
        _createVNode(_component_a_menu, {
          mode: "inline",
          selectable: false,
          class: "custom-menu"
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.children, (child) => {
              return (_openBlock(), _createBlock(_component_a_menu_item, {
                key: child.id
              }, {
                default: _withCtx(() => [
                  _hoisted_3,
                  _createTextVNode(" " + _toDisplayString(child.title), 1)
                ]),
                _: 2
              }, 1024))
            }), 128))
          ]),
          _: 2
        }, 1024)
      ]))
    }), 128))
  ]))
}
}

})